import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getStarterDashboardCommentsPageData } from './api';
import type { StarterDashboardCommentsPageDataErrorCode } from './types';

export const {
	Context: StarterDashboardCommentsPageDataContext,
	Provider: StarterDashboardCommentsPageDataContextProvider,
	useContext: useStarterDashboardCommentsPageData,
	useAsyncData: useStarterDashboardCommentsDataFromApi,
	prefetchAsyncData: prefetchStarterDashboardCommentsDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'StarterDashboardCommentsPageDataContext',
	dataProperty: 'pageData',
	getData: getStarterDashboardCommentsPageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler<StarterDashboardCommentsPageDataErrorCode>(),
});
